// Mixins
import { stickyMenuMixins } from '@/app/mixins/components/sticky-menu-mixins.js';
import { notificationMixins } from '@/app/mixins/components/notification-mixins.js';
import { userMixins } from '@/app/mixins/modules/user-mixins';
import { comingSoonMixins } from '@/app/mixins/utils/coming-soon-mixins';

// Event Bus
import EventBus from '@/app/bus/event-bus.js';

export default {
	name: 'TheStickyMenu',
	mixins: [
		stickyMenuMixins,
		userMixins,
		notificationMixins,
		comingSoonMixins
	],
	data() {
		return {
			hasProfileImage: false,
			isStickyMenuShown: true
		}
	},
	created() {
		EventBus.$on('showStickyMenu', isStickyMenuShown => {
			this.isStickyMenuShown = isStickyMenuShown;
		});
	},
	beforeDestroy() {
		this.unbindScrollStickyMenu();
	}
}